import type { identifyDomainLlist } from '@/api/domainAuth/data.d';
import type { CommonOptionsType } from '@/definition/common/data.d';
import { intlGet } from '@/locales';
// DKIM、SPF、认证状态
export enum ValidationStateNum {
  // 认证成功
  VERIFED = 1,
  // 未认证
  NOT_VERIFED = 0,
}

// 沙盒状态
export enum SandBoxValidationStateNum {
  // 认证成功  10 是移除沙盒，quta 等操作完成
  VERIFED = 10,
}

/**  icon - 类型 */
export type StatusIconType = 'warning' | 'error' | 'success';

export enum StatusIconTypeEnum {
  WARNING = 'warning',
  ERROR = 'error',
  SUCCESS = 'success',
}

/** 显示状态模块 icon类型及配色 */
export const statusIconTypeArr: { type: string; style: any }[] = [
  {
    type: StatusIconTypeEnum.WARNING,
    style: {
      background: 'rgba(255, 157, 0, .15)',
      color: '#FF9D00',
    },
  },
  {
    type: StatusIconTypeEnum.ERROR,
    style: {
      background: 'rgba(229, 69, 69, .15)',
      color: '#e54545',
    },
  },
  {
    type: StatusIconTypeEnum.SUCCESS,
    style: {
      background: 'rgba(20, 204, 151, .15)',
      color: '#00A386',
    },
  },
];
export const statusOptions: CommonOptionsType[] = [
  {
    labelKey: 'SETTING.MANAGE.DOMAIN.AUTH.LIST.OPERATE.NOT.VERIFY',
    value: 0,
    theme: 'danger',
  },
  {
    labelKey: 'SETTING.MANAGE.DOMAIN.AUTH.LIST.OPERATE.VERIFY',
    value: 1,
    theme: 'primary',
  },
];

/**
 * 1. 域名验证：DKIM和SPF信息有原始的一组变更为两组。
 * 1.1 DKIM标题右侧状态：两组DKIM状态都显示成功，DKIM标题右侧状态才显示成功。
 * 1.2 SPF标题右侧状态：两组SPF状态都显示成功，SPF标题右侧状态才显示成功。
 * 1.3 DKIM和SPF的Table表格信息，各自增加一列显示状态。
 * 1.4 SPF的表格数据中共三条数据(两条MX，一条TXT)，只要任意一个MX状态是成功的，TXT状态则显示成功
 */
export const dealStatus = (
  valArr: identifyDomainLlist[],
  key: 'dkimStatus' | 'spfStatus' | 'dmarcStatus',
) => {
  const statusRes =
    key !== 'spfStatus'
      ? valArr.every((item) => item[key])
      : valArr.some((item) => item[key]);
  return statusRes
    ? ValidationStateNum.VERIFED
    : ValidationStateNum.NOT_VERIFED;
};

// 域名验证
export enum statusTypeEnum {
  DKIM = 'DKIM',
  SPF = 'SPF',
  DMARC = 'DMARC',
  GMAIL = 'GMAIL',
}

// 验证状态文案
export const statusConfigText = (status: number) => {
  let text = '';
  switch (status) {
    case ValidationStateNum.VERIFED:
      text = intlGet('SETTING.MANAGE.DOMAIN.AUTH.LIST.OPERATE.VERIFY');
      break;
    case ValidationStateNum.NOT_VERIFED:
      text = intlGet('SETTING.MANAGE.DOMAIN.AUTH.LIST.OPERATE.NOT.VERIFY');
      break;
    default:
      return;
  }
  return text;
};
